import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
// Energy providers list for texas
import { energy_providers } from '../../../../../assets/energy-providers-tx';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q28',
  templateUrl: './r-q28.component.html',
  styleUrls: ['./r-q28.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ28Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  showTip = false;
  currentProvider;
  energy_providers_list;
  deviceWidth;
  showbutton = true;
  timer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.energy_providers_list = energy_providers.texas_ep;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {'res_question_id': this.questionObj._id});
      if (!_.isEmpty(obj)) {
        this.currentProvider = obj.fieldValue;
       
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
      // else {
      //   this.currentProvider = 'Select Providers';
      // }
    }
    if (_.isEmpty(this.currentProvider))
    {
      this.showbutton = false;
    }
  }

  getCurrentProvider(event) {
    const provider = this.currentProvider;
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    if (!_.isEmpty(this.currentProvider)) {
      if (_.contains(this.energy_providers_list, this.currentProvider)) {
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }else
        {
          
            if(!this.showbutton)
            {
              this.next();
            }
          
        }
      } else {
        this.user_bot = false;
      }
    } else {
      this.user_bot = false;
    }
  }

  next() {
    if (_.isEmpty(this.currentProvider) || this.user_bot === false) {
      // alert('Please select your current energy provider.');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.user_bot = true;
      const Obj = {
        'res_question_id': this.data,
        'fieldName': 'current_provider',
        'fieldValue': this.currentProvider
      };
      this.residentialService.updateResponses(Obj);
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
}
